import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Switch } from 'react-router-dom';
import ApplicationRoutes from './Routes/Routes';
import AppRoute from './Routes/AppRoute';
import { Provider } from 'react-redux';
import createStore from './store/Store';
import CustomPrompt from "../App/Common/Components/CustomPrompt";

const { App, Routes } = ApplicationRoutes;

const getUserConfirmation = (message, callback) => {
    const modal = document.createElement('div')
    document.body.appendChild(modal)

    const withCleanup = (answer) => {
        ReactDOM.unmountComponentAtNode(modal)
        document.body.removeChild(modal)
        callback(answer)
    }

    ReactDOM.render(<CustomPrompt message={message} withCleanup={withCleanup} />, modal);
}

const Portico = () => {
    return (
        <div>
            <Provider store={createStore()}>
                <HashRouter getUserConfirmation={getUserConfirmation}>
                    <div>
                        <App>
                            <Switch>
                                {Routes.map(route =>
                                    <AppRoute
                                        exact={route.exact}
                                        path={route.path}
                                        component={route.component}
                                        isPrivate={route.isPrivate}
                                    />
                                )}
                            </Switch>
                        </App>
                    </div>
                </HashRouter>
            </Provider>
        </div>
    );
};

ReactDOM.render(<Portico />, document.getElementById('App'));



// WEBPACK FOOTER //
// ./Portico/App/index.js